import { crudMdActions } from "@/services/CrudMdActions";

// Partes that have consumed hours of a pack (tab of the pack edit view)
export default {
  name() {
    return "packs-horas-consumos";
  },
  ...crudMdActions("packs-horas-consumos"),
};
